;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import { useState } from 'react';
import { useUnmount } from 'react-use';

export const useWait = () => {
    const [timeoutIds, setTimeoutIds] = useState([]);

    useUnmount(() => {
        timeoutIds.map(clearTimeout);
    });

    return function wait(ms) {
        let timeoutId;
        const promise = new Promise(resolve => {
            timeoutId = setTimeout(resolve, ms);
        });
        setTimeoutIds([...timeoutIds, timeoutId]);
        return promise;
    };
};

export default useWait;
